import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import { Input, Btn } from '../components/Input';
import { IconEnvelopeSent, IconKey } from '../components/AuthIcons';

export default function ForgotPassword({ onBack }) {
  const { t } = useTranslation();
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: '380px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: 800, color: 'var(--acc2)', letterSpacing: '-0.02em', marginBottom: '6px' }}>
            ScanPilots
          </h1>
          <p style={{ fontSize: '12px', color: 'var(--ink3)', fontWeight: 500 }}>
            {t('auth.tagline')}
          </p>
        </div>

        <div className="ds-card" style={{ padding: '28px 24px' }}>
          {sent ? (
            /* ── Potwierdzenie wysyłki ── */
            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}><IconEnvelopeSent size={56} /></div>
              <h2 style={{ fontSize: '15px', fontWeight: 700, color: 'var(--ink)', marginBottom: '10px' }}>
                {t('auth.resetEmailSentTitle')}
              </h2>
              <p style={{ fontSize: '12px', color: 'var(--ink3)', lineHeight: '1.6', marginBottom: '24px' }}>
                {t('auth.resetEmailSentDesc', { email })}
              </p>
              <Btn variant="ghost" onClick={onBack} style={{ width: '100%' }}>
                ← {t('auth.backToLogin')}
              </Btn>
            </div>
          ) : (
            /* ── Formularz ── */
            <>
              <h2 style={{ fontSize: '14px', fontWeight: 700, color: 'var(--ink)', marginBottom: '6px' }}>
                {t('auth.forgotPassword')}
              </h2>
              <p style={{ fontSize: '11px', color: 'var(--ink3)', marginBottom: '20px', lineHeight: '1.5' }}>
                {t('auth.forgotPasswordDesc')}
              </p>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                <Input
                  label={t('auth.email')}
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="twoj@email.com"
                  required
                  autoFocus
                />

                {error && (
                  <div style={{
                    padding: '10px 12px',
                    background: 'rgba(176,88,72,0.12)',
                    border: '1px solid rgba(176,88,72,0.3)',
                    borderRadius: '8px',
                    fontSize: '11px',
                    color: 'var(--err2)',
                  }}>
                    {error}
                  </div>
                )}

                <Btn type="submit" variant="primary" disabled={loading}
                  style={{ width: '100%', padding: '10px 14px', fontSize: '11px', marginTop: '4px' }}>
                  {loading ? t('auth.sending') : t('auth.sendResetLink')}
                </Btn>
              </form>
            </>
          )}
        </div>

        {!sent && (
          <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '11px', color: 'var(--ink3)' }}>
            <button onClick={onBack}
              style={{ background: 'none', border: 'none', color: 'var(--acc2)', fontWeight: 600, cursor: 'pointer', fontSize: '11px', padding: 0 }}>
              ← {t('auth.backToLogin')}
            </button>
          </p>
        )}
      </div>
    </div>
  );
}
